<template>
	<div>
		<!--
		<div class="white">
			<div class="row">
				<div class="col-20">

					<div class="toolbar">
						<nav class="subnav">
							<ul>
								<li><router-link to="/content">Dashboard</router-link></li>
								<li><router-link to="/content/stats">Stats</router-link></li>
							</ul>
						</nav>
					</div>

				</div>
			</div>
		</div>
		-->

		<Dashboard :type="type"></Dashboard>

	</div>
</template>

<script>

import Dashboard from '../../components/dashboard/Dashboard.vue'

export default {
	name: 'ContentDashboard',
	components: {
		'Dashboard': Dashboard
	},

	data () {
		return {
			type: this.getMainSlug()
		}
	},

	methods: {
		getMainSlug () {
			var pathName = window.location.pathname
			return pathName.split('/')[1]
		}
	}
}

</script>
